var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "comment-input-wrapper" },
    [
      _c("div", { staticClass: "comment-input" }, [
        _c("div", {
          staticClass: "close-area",
          on: { click: _vm.openQuitWarning }
        }),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "leave-container",
            class: { "leave-container-transform": _vm.callQuitWarning }
          },
          [
            _c("div", { staticClass: "leave-main" }, [
              _c("div", { on: { click: _vm.leaveFocus } }, [
                _c("textarea", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.inputContent,
                      expression: "inputContent"
                    }
                  ],
                  ref: "leaveFocus",
                  staticClass: "leave-textarea",
                  attrs: {
                    maxlength: "100",
                    placeholder: _vm.commentInputPlaceholder
                  },
                  domProps: { value: _vm.inputContent },
                  on: {
                    blur: _vm.leaveBlur,
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.inputContent = $event.target.value
                    }
                  }
                })
              ]),
              _vm._v(" "),
              _vm.imgBase64.length > 0
                ? _c(
                    "div",
                    { staticClass: "leave-img" },
                    _vm._l(_vm.imgBase64, function(uploadFile, index) {
                      return _c(
                        "div",
                        { key: index, staticClass: "leave-select-img" },
                        [
                          _c("img", {
                            staticClass: "upload-img source-img",
                            attrs: { src: uploadFile.FileUrl },
                            on: {
                              click: function($event) {
                                $event.stopPropagation()
                                return _vm.showImg(index, _vm.imgBase64)
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "close-img",
                              on: {
                                click: function($event) {
                                  $event.stopPropagation()
                                  return _vm.deleteImg(index)
                                }
                              }
                            },
                            [_c("span", { staticClass: "close-span" })]
                          )
                        ]
                      )
                    }),
                    0
                  )
                : _vm._e()
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "leave-footer" }, [
              _vm.authType == "WECHAT"
                ? _c("div", { staticClass: "upload-input-wrapper" }, [
                    _c("input", {
                      ref: "uploadInput",
                      staticClass: "upload-input",
                      attrs: {
                        type: "file",
                        name: "imgfiles",
                        id: "test",
                        multiple: "multiple",
                        accept: "image/*"
                      },
                      on: {
                        change: function($event) {
                          return _vm.uploadImage($event)
                        }
                      }
                    })
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.authType == "TOOLKIT"
                ? _c("div", {
                    staticClass: "upload-input-wrapper",
                    on: {
                      click: function($event) {
                        return _vm.chooseImg()
                      }
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              _c("div"),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "footer-btn",
                  class: {
                    "footer-btn-clickable":
                      (_vm.commentContentNoSpace.length ||
                        _vm.imgBase64.length) &&
                      _vm.submitOnOff
                  },
                  on: { click: _vm.publish }
                },
                [_vm._v("发布")]
              )
            ])
          ]
        )
      ]),
      _vm._v(" "),
      _vm.callQuitWarning
        ? _c("quit-message", {
            attrs: {
              messageTitle: _vm.messageTitle,
              messageText: _vm.messageText,
              queryBtn: _vm.queryBtn
            },
            on: {
              closeQuitWarning: _vm.closeQuitWarning,
              eventContinue: _vm.eventContinue
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.sourceList && _vm.sourceList.length
        ? _c("photo-package", {
            ref: "sourcePreview",
            attrs: {
              list: _vm.sourceList,
              options: _vm.options,
              selector: ".source-img"
            },
            on: { "on-close": _vm.closeHandler }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-loader/node_modules/vue-hot-reload-api")      .rerender("data-v-05563546", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-05563546","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/components/leaveQuestion.vue
// module id = null
// module chunks = 